import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import { useParams } from 'react-router-dom';
 import CarForm from '../../components/Entity/Cars/Update/CarForm';

const FinancePage = () => { 
  const { id } = useParams();

  return <Layout > 
       <CarForm id={id} isAdd={false}></CarForm>  
  </Layout>;
}

export default FinancePage;